// extracted by mini-css-extract-plugin
module.exports = {"swiperContent":"mOI3Mbd_","swiper":"qKDxEwxP","list":"FDqgrDwq"};